import { Component, OnInit, ViewChild, ElementRef, HostListener, Renderer2, ChangeDetectorRef } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthCustomerSelectComponent } from 'src/app/auth-customer-select/auth-customer-select.component';
import { CompanySelectResponse } from 'src/app/models/company-select-response';
import { AuthenticationService } from 'src/services/authentication/authentication.service';
import { CustomerService } from 'src/services/authentication/customer.service';
import { TraxCustomer } from 'src/app/models/trax-customer';
import { Distributor } from 'src/app/models/distributor';
import { FTLCustomerBetaList } from 'src/app/models/ftl-customer-beta-list';

@Component({
  selector: 'ftl-quote-external-header',
  templateUrl: './oidc-user-header.component.html',
  styleUrls: ['./oidc-user-header.component.scss']
})
export class OidcUserHeaderComponent implements OnInit {

  @ViewChild('priorityNav', { static: false }) private priorityNav: ElementRef;
  @ViewChild('priorityNavMore', { static: false }) private priorityNavMore: ElementRef;

  isAtTop = true;
  isLargeScreenWidth = true;
  isBetaUser = false;
  isMenuOpened = false;
  priorityNavHeight = 0;
  moreOrder = 100;


  // 992px inclusive corresponds with large devices ('lg') in Bootstrap 4.1
  largeScreenLowerBound = 992;

  traxClientUrl = environment.traxClientUrl;
  traxLtlClientUrl = environment.traxLtlClientUrl;
  omassClientUrlWithAuthorize = environment.omassPortalClientUrl + '/authorize';
  // IMPORTANT: a menuItem cannot have the same displayName as another menuItem or the priority navigation functionality might break
  menuItems_Default = [
    {
      displayName: 'Loads',
      url: `${this.traxClientUrl}/loads`
    },
    {
      displayName: 'Get Quote',
      children: [
        {
          displayName: 'FTL',
          route: '/loadDetails'
        },
        {
          displayName: 'LTL',
          url: `${this.traxLtlClientUrl}/trax/quoteDetails`
        }
      ]
    },
    {
      displayName: 'Tender a Load',
      children: [
        {
          displayName: 'Tender FTL',
          route: '/loadDetailsTender'
        },
        {
          displayName: 'Tender LTL',
          url: `${this.traxLtlClientUrl}/trax/quoteboard`
        }
      ]
    },
    {
      displayName: 'Accounts Payable',
      url: `${this.traxClientUrl}/accounts-payable`
    },
    {
      displayName: 'Contact Rep',
      url: `${this.traxClientUrl}/contact-rep`
    },
    {
      displayName: 'Reporting',
      url: `${this.traxClientUrl}/reporting`
    }
  ];
  menuItems_BetaUser = [
    {
      displayName: 'Loads',
      url: `${this.traxClientUrl}/loads`
    },
    {
      displayName: 'Get Quote',
      children: [
        {
          displayName: 'FTL',
          route: '/loadDetails'
        },
        {
          displayName: 'LTL',
          url: `${this.traxLtlClientUrl}/trax/quoteDetails`
        },
        {
          displayName: 'Air',
          url: `${this.omassClientUrlWithAuthorize}?mode=air`
        },
        {
          displayName: 'Customs',
          url: `${this.omassClientUrlWithAuthorize}?mode=customs`
        },
        {
          displayName: 'Drayage',
          url: `${this.omassClientUrlWithAuthorize}?mode=drayage`
        },
        {
          displayName: 'Drop Trailer',
          url: `${this.omassClientUrlWithAuthorize}?mode=drop_trailer`
        },
        {
          displayName: 'Intermodal',
          url: `${this.omassClientUrlWithAuthorize}?mode=intermodal`
        },
        {
          displayName: 'Ocean FCL',
          url: `${this.omassClientUrlWithAuthorize}?mode=ocean_fcl`
        },
        {
          displayName: 'Ocean LCL',
          url: `${this.omassClientUrlWithAuthorize}?mode=ocean_lcl`
        },
        {
          displayName: 'Warehousing',
          url: `${this.omassClientUrlWithAuthorize}?mode=warehouse`
        }
      ]
    },
    {
      displayName: 'Tender a Load',
      children: [
        {
          displayName: 'Tender FTL',
          route: '/loadDetailsTender'
        },
        {
          displayName: 'Tender LTL',
          url: `${this.traxLtlClientUrl}/trax/quoteboard`
        }
      ]
    },
    {
      displayName: 'Accounts Payable',
      url: `${this.traxClientUrl}/accounts-payable`
    },
    {
      displayName: 'Contact Rep',
      url: `${this.traxClientUrl}/contact-rep`
    },
    {
      displayName: 'Reporting',
      url: `${this.traxClientUrl}/reporting`
    }
  ];

  // holds all menu items available for display - to be set with either menuItems_Default or menuItems_Distributor
  menuItems = [];

  // holds the items that appears under the More tab when there is an overflow
  moreMenuItems = [];

  // hold the nodeList of priority-nav-item nodes in Array form
  priorityNavItems = [];

  companyName: string = '';
  traxAdminUrl: string = `${this.traxClientUrl}/admin`;
  traxFAQUrl: string = `${this.traxClientUrl}/faq`;

  // holds the customers and distributors for company switching
  private customerList: TraxCustomer[] = [];
  private activeCustomer: TraxCustomer | undefined;
  private distributorList: Distributor[] = [];

  constructor(
    private renderer: Renderer2,
    private modalService: NgbModal,
    private authService: AuthenticationService,
    private customerService: CustomerService,
    private cRef: ChangeDetectorRef
  ) {
    this.menuItems = this.menuItems_Default;
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    if (window.pageYOffset === 0) {
      this.isAtTop = true;
    } else {
      this.isAtTop = false;
    }
  };

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setIsLargeScreenWidth();

    if (this.priorityNav && this.priorityNavMore) {
      this.setPriorityNavHeight();
      this.resetMenuItemVisibility();
    }
  };


  ngOnInit() {
    this.setIsLargeScreenWidth();
    this.authService.loggedInObservable.subscribe(() => {
      this.getCustomerList();
    })
  }

  ngAfterViewInit() {
    if (this.priorityNav && this.priorityNavMore) {
      this.setPriorityNavHeight();

      // PriorityNavItems must be set before menu item orders and visibility can be set
      this.setPriorityNavItems();

      // Loop for setting flex order should always come before the loop for setting visibility because flex order affects
      // offsetTop values, which are used to determine visibility
      this.setInitialMenuItemOrder();
      setTimeout(() => {
        this.setInitalMenuItemVisibility();
      }, 1);
    }
  }

  setupForBetaUser() {    
    if (this.isBetaUser) {
      this.menuItems = this.menuItems_BetaUser;
    }
  }

  setPriorityNavHeight() {
    // to vertically center the menu in medium to large view, we will force the height to be equal to the height of a menu item
    this.priorityNavHeight = this.priorityNavMore.nativeElement.offsetHeight;
    this.renderer.setStyle(this.priorityNav.nativeElement, 'height', this.priorityNavHeight.toString() + 'px');
  }

  setPriorityNavItems() {
    this.priorityNavItems = Array.prototype.slice.apply(this.priorityNav.nativeElement.querySelectorAll('.priority-nav-item'));
  }

  setIsLargeScreenWidth() {
    if (window.innerWidth < this.largeScreenLowerBound) {
      this.isLargeScreenWidth = false;
    } else {
      this.isLargeScreenWidth = true;
    }
  }

  setInitialMenuItemOrder() {
    this.priorityNavItems.forEach(priorityNavItem => {
      let index = this.priorityNavItems.indexOf(priorityNavItem);
      this.renderer.setStyle(priorityNavItem, 'order', index.toString());
    });
  }

  setInitalMenuItemVisibility() {
    let priorityNavItemsCopy = this.priorityNavItems.slice();
    priorityNavItemsCopy.reverse().forEach(priorityNavItem => {
      if (priorityNavItem.offsetTop > this.priorityNav.nativeElement.offsetTop) {
        this.movePriorityNavItem_MainToMore(priorityNavItem, null);
      }
    });
    setTimeout(() => {
      this.adjustForMoreDropdown();
    }, 1);
  }

  resetMenuItemVisibility() {
    let useSetTimeOut = false;
    let firstWrappedNavItemOrder = this.priorityNavItems.length - 1;
    this.priorityNavItems.forEach(priorityNavItem => {
      if (priorityNavItem.offsetTop === this.priorityNav.nativeElement.offsetTop) {
        if (priorityNavItem.classList.contains('invisible')) {
          this.movePriorityNavItem_MoreToMain(priorityNavItem);
        }
      } else {
        if (!priorityNavItem.classList.contains('invisible')) {
          if (this.priorityNavItems.indexOf(priorityNavItem) < firstWrappedNavItemOrder) {
            firstWrappedNavItemOrder = this.priorityNavItems.indexOf(priorityNavItem);
          }
          this.movePriorityNavItem_MainToMore(priorityNavItem, firstWrappedNavItemOrder - 1);
          useSetTimeOut = true;
        }
      }
    });
    // setTimeout(fn, 0) causes pause and does not have the same effect as just calling the function
    if (useSetTimeOut) {
      setTimeout(() => {
        this.adjustForMoreDropdown();
      }, 1);
    } else {
      this.adjustForMoreDropdown();
    }
  }

  adjustForMoreDropdown() {
    if (this.priorityNavMore.nativeElement.offsetTop > this.priorityNav.nativeElement.offsetTop) {
      let priorityNavItemsCopy = this.priorityNavItems.slice();
      let lastVisibleItem = priorityNavItemsCopy.reverse().find(priorityNavItem => !priorityNavItem.classList.contains('invisible'));
      this.movePriorityNavItem_MainToMore(lastVisibleItem, null);
    }
  }

  movePriorityNavItem_MainToMore(priorityNavItemToMove: any, moreOrder: number) {
    priorityNavItemToMove.classList.add('invisible');
    let displayName = String(priorityNavItemToMove.textContent);
    let menuItem = this.menuItems.find(menuItem => displayName.toLowerCase().includes(menuItem.displayName.toLowerCase()));
    this.addToMoreMenu(menuItem);
    this.moreOrder = moreOrder || this.priorityNavItems.indexOf(priorityNavItemToMove) - 1;
  }

  movePriorityNavItem_MoreToMain(priorityNavItemToMove: any) {
    priorityNavItemToMove.classList.remove('invisible');
    let displayName = String(priorityNavItemToMove.textContent);
    let menuItem = this.menuItems.find(menuItem => displayName.toLowerCase().includes(menuItem.displayName.toLowerCase()));
    this.removeFromMoreMenu(menuItem);
    this.moreOrder = this.priorityNavItems.indexOf(priorityNavItemToMove);
  }

  addToMoreMenu(menuItemToAdd: any) {
    if (!this.moreMenuItems.find(menuItem => menuItem.displayName.toLowerCase() == menuItemToAdd.displayName.toLowerCase())) {
      this.moreMenuItems.push(menuItemToAdd);
    }
  }

  removeFromMoreMenu(menuItemToRemove: any) {
    let index = this.moreMenuItems.findIndex(menuItem => menuItem.displayName.toLowerCase() === menuItemToRemove.displayName.toLowerCase());
    if (index >= 0) {
      this.moreMenuItems.splice(index, 1);
    }
  }

  trackByFn(index) {
    return index;
  }

  shouldDisplayCustomerSelect() {
    return this.isMultiCompanyUser();
  }

  openCustomerSelect() {
    const modalRef = this.modalService.open(AuthCustomerSelectComponent, { windowClass: 'company-select-modal', centered: true, backdrop: 'static' });
    modalRef.componentInstance.customers = this.customerList;
    modalRef.result.then((result: CompanySelectResponse) => {
      modalRef.close();
      if (result !== undefined && result !== null) {
        window.location.href = result.navigationRoute;
      }
    });
  }


  navigateTo(url: string) {
    let dynChar = url.indexOf('?') > 0 ? '&' : '?';
    window.location.href = `${url}${dynChar}CompanyId=${this.authService.getCompanyId()}&AccountType=${this.authService.getAccountType()}`;
  }

  private isMultiCompanyUser(): boolean {
    let customers = this.authService.getAllCustomerIds();
    customers = customers === undefined || customers === null ? [] : customers;
    return customers.length > 1;
  }

  private getCustomerList() {
    this.customerService.getCustomersForUser().subscribe(customers => {
      this.customerList = customers;
      let customerId = this.authService.getCompanyId();
      this.activeCustomer = this.customerList.find(c => c.customerId === customerId);
      if (this.activeCustomer) {        
        this.companyName = this.activeCustomer.customerName;
        this.authService.setSelectedCompany(this.activeCustomer.customerId, this.activeCustomer.userType);
        this.activeCustomer.customerId = customerId;
        if (this.authService.isLoggedIn()) {        
          if (FTLCustomerBetaList.find((betaId) => betaId == this.activeCustomer.customerId ? true : false)) {
            this.isBetaUser = true;
            this.setupForBetaUser();
            this.updateMenu();
          }
        }
      } else if(this.customerList.length > 0) {        
        this.companyName = this.customerList[0].customerName;        
        this.authService.setSelectedCompany(this.customerList[0].customerId, this.customerList[0].userType);
      }
    }, error => {
      console.log(error);
    });
  }
  
  private updateMenu() {
    this.menuItems = this.filterMenuItemsByAccess(this.menuItems)
    this.cRef.detectChanges()
    this.setPriorityNavItems();
  }
  private filterMenuItemsByAccess(menuItems) {
    // stripped of logic for Accounts Payable
    // remains in place to mimic ltl-shipments code base...
    return menuItems;
  }

}
